jQuery(function ($) {
    $('.js-quotes-carousel').each(function() {
        const $carousel = $(this);
        const $parent   = $carousel.parent(); 

        // Initialize Swiper with dynamic effect
        new Swiper(this, {
            loop: true,
            autoplay: true,
            speed: 300,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            pagination: {
                el: $parent.find('.swiper-dots')[0],
            },
            navigation: {
                nextEl: $parent.find('.js-img-next.swiper-control')[0],
                prevEl: $parent.find('.js-img-prev.swiper-control')[0],
            },
            scrollbar: {
                el: $parent.find('.swiper-scrollbar')[0],
            },
        });
    });
});